module.exports = __webpack_public_path__ + "img/10.691c7722.jpg";